var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ff-radio-component"},[_c('el-radio-group',{model:{value:(_vm.radio),callback:function ($$v) {_vm.radio=$$v},expression:"radio"}},_vm._l((_vm.lists),function(list,index){return _c('el-radio',{key:list.value,attrs:{"size":"mini","label":list.value}},[_vm._v("\n      "+_vm._s(list.label)+"\n    ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }